import React from "react";
import { Card, Row, Col, Input, Button, Alert } from "antd";
import { CheckCircleOutlined, CloseOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useHasar } from "./HasarContext";
import "./KaskoIhbarBasariliPage.css";

const { TextArea } = Input;

function KaskoIhbarBasariliPage() {
    const navigate = useNavigate();
    const { ihbarResponse } = useHasar();

    // Eğer response yoksa ana sayfaya yönlendir
    React.useEffect(() => {
        if (!ihbarResponse || !ihbarResponse.dosyaNo) {
            navigate("/");
        }
    }, [ihbarResponse, navigate]);

    const handleClose = () => {
        navigate("/");
    };

    const handleYeniIhbar = () => {
        navigate("/");
    };

    // Masabaşı eksper kodları
    const masabasiEksperKodlari = ["9571", "9847", "9827", "9826", "9790", "9861", "9963"];

    // Eksper kodunu kontrol et ve mesajı belirle
    const getEksperMessage = () => {
        const eksperKodu = ihbarResponse?.dosyaEksperKodu?.toString() || "";
        
        if (masabasiEksperKodlari.includes(eksperKodu)) {
            return "Dosyanıza Zurich Sigorta Masabaşı Hasar Uzmanı atanmış olup işlemleriniz uzaktan yönetilecek, araç yerinde görülmeyecektir:\n\nİletişim bilgilerinde yer alan whatsapp hattına ya da e-posta adresine hasarlı aracın detaylı hasar fotoğrafları, hasar evrakları, hasar tespit detayını ve iletişim bilgilerini gönderirseniz, masabaşı uzmanımız size aynı yol ile geri dönüş sağlayıp yardımcı olacaktır.\n\nWhatsapp hattı sadece mesajlaşma içindir, dışarıdan aramalara kapalıdır.";
        } else {
            return "Dosyanıza atanan Eksper 1 iş günü içerisinde serviste aracı görmek için ziyaret edecektir. Eksper incelemesini tamamlayıp raporunu bize iletecek ve dosya sorumlunuz tarafından son kontroller yapılarak dosyanız sonuçlandırılacaktır.";
        }
    };

    return (
        <div className="basarili-container">
            <Card className="basarili-card">
                <div className="basarili-header">
                    <Button
                        type="text"
                        icon={<CloseOutlined />}
                        onClick={handleClose}
                        className="close-button"
                    />
                </div>
                
                <Alert
                    message="Hasar dosyası başarı ile açıldı."
                    type="success"
                    showIcon
                    icon={<CheckCircleOutlined />}
                    className="success-alert"
                />

                <div className="basarili-form">
                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12}>
                            <label className="form-label">Hasar Dosya No:</label>
                            <Input
                                value={ihbarResponse?.dosyaNo || ""}
                                readOnly
                                className="form-input"
                            />
                        </Col>
                        <Col xs={24} sm={12}>
                            <label className="form-label">Dosyanıza Atanan Eksper:</label>
                            <Input
                                value={ihbarResponse?.dosyaEksperi || ""}
                                readOnly
                                className="form-input"
                            />
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col xs={24} sm={12}>
                            <label className="form-label">Atanan Eksper Telefon Numarası:</label>
                            <Input
                                value={ihbarResponse?.eksperTel || ""}
                                readOnly
                                className="form-input"
                            />
                        </Col>
                        <Col xs={24} sm={12}>
                            <label className="form-label">Atanan Eksper Whatsapp Hat:</label>
                            <Input
                                value={ihbarResponse?.eksperWp || ""}
                                readOnly
                                className="form-input"
                            />
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]}>
                        <Col xs={24}>
                            <label className="form-label">GEREKLİ BİLGİLENDİRMELER VE YÖNLENDİRMELER</label>
                            <TextArea
                                value={getEksperMessage()}
                                readOnly
                                rows={6}
                                className="form-textarea"
                            />
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]} style={{ marginTop: '24px' }}>
                        <Col xs={24} style={{ display: 'flex', justifyContent: 'center' }}>
                            <Button
                                type="primary"
                                size="large"
                                icon={<PlusOutlined />}
                                onClick={handleYeniIhbar}
                                className="yeni-ihbar-button"
                            >
                                Yeni İhbar Oluştur
                            </Button>
                        </Col>
                    </Row>
                </div>
            </Card>
        </div>
    );
}

export default KaskoIhbarBasariliPage;
